<template>
  <v-dialog v-model="modal" scrollable>
    <v-card>
      <v-card-title>Pourquoi certaines actions sont indisponibles ?</v-card-title>
      <v-card-text>
        <h1>Générer un extrait</h1>
        <p>
          La génération d'un extrait est disponible pour les associations ne présentant
          pas de données non conformes dans le registre.
        </p>
        <p>
          Ces non-conformités sont traitées par les tribunaux d'Alsace-Moselle. En cas de
          besoin vous pouvez prendre contact avec le greffe du tribunal dans le ressort
          duquel est situé le siège de l'association.
        </p>
        <h1>Déposer une requête de modification</h1>
        <p>
          Avant de pouvoir déposer une requête de modification sur une de vos
          associations, vous devez au préalable y être rattaché et disposer des droits de
          dépôt nécessaires sur celle-ci.
        </p>
        <p>
          Si une requête est déjà en cours d'instruction par le greffe sur votre
          association, le dépôt d'une nouvelle requête sera temporairement indisponible le
          temps de l'instruction.
        </p>
        <p>
          L'association sur laquelle vous souhaitez déposer votre requête de modification
          ne doit pas être dissoute ou radiée du registre et ne doit pas présenter de
          données non conformes.
        </p>
        <h1>Déposer une requête de dissolution</h1>
        <p>
          Avant de pouvoir déposer une requête de dissolution sur une de vos associations,
          vous devez au préalable y être rattaché et disposer des droits de dépôt
          nécessaires sur celle-ci.
        </p>
        <p>
          Si une requête est déjà en cours d'instruction par le greffe sur votre
          association, le dépôt d'une nouvelle requête sera temporairement indisponible le
          temps de l'instruction.
        </p>
        <p>
          L'association sur laquelle vous souhaitez déposer votre requête de dissolution
          ne doit pas déjà être dissoute ou radiée du registre et ne doit pas présenter de
          données non conformes.
        </p>
        <h1>Déposer une requête de radiation</h1>
        <p>
          Avant de pouvoir déposer une requête de radiation sur une de vos associations,
          vous devez au préalable y être rattaché et disposer des droits de dépôt
          nécessaires sur celle-ci.
        </p>
        <p>
          Si une requête est déjà en cours d'instruction par le greffe sur votre
          association, le dépôt d'une nouvelle requête sera temporairement indisponible le
          temps de l'instruction.
        </p>
        <p>
          L'association sur laquelle vous souhaitez déposer votre requête de radiation
          doit déjà être dissoute du registre et ne doit pas présenter de données non
          conformes.
        </p>
        <h1>Demander une numérisation des archives</h1>
        <p>
          La numérisation des archives est possible par l'EPELFI si un dossier au format
          papier existe. C'est le cas pour la majorité des associations créées avant avril
          2023. Pour les associations créées après avril 2023 l'ensemble des documents au
          format papier est déjà numérisé et disponible dans le registre.
        </p>
        <p>
          Vous retrouverez les documents relatifs à une association dans l'onglet «
          DOCUMENTS » en consultant ses données dans le registre.
        </p>
        <p>
          Si la numérisation des archives d'une association a déjà été réalisée par
          l'EPELFI vous retrouverez également le fichier associé dans l'onglet « DOCUMENTS
          » en consultant ses données dans le registre.
        </p>
        <p>
          Si la numérisation est déjà réalisée, la demande d'une nouvelle numérisation n'a
          pas lieu d'être. Les nouveaux documents de l'association apparaitront au fur et
          à mesure de sa vie automatiquement dans le registre.
        </p>

        <div style="height:100px;"/>
        <p>
          Pour toutes autres questions vous pouvez contacter le support EPELFI :<br /><br />
          EPELFI<br />
          2A Rue de l'Artisanat<br />
          67700 Saverne<br />
          Support : 0800 206 126 / associations.epelfi@justice.fr
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="fermer" @click="ferme">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import makeDialog from "@/mixins/makeDialog";

export default {
  mixins: [makeDialog],
};
</script>
